import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'

import s from './Typography.module.scss'
const cn = classNames.bind(s)

// HEADLINE HERO (GT America Extended Bold)
export const HeadlineHero = ({ className, as = 'h3', ...props }) => {
  const Element = as
  return <Element className={cn('headlineHero', className)} {...props} />
}

HeadlineHero.propTypes = {
  as: PropTypes.string,
  className: PropTypes.string,
}

// HEADLINE 1 (GT America Standard Bold)
export const Headline1 = ({ className, as = 'h1', ...props }) => {
  const Element = as
  return <Element className={cn('headline1', className)} {...props} />
}

Headline1.propTypes = {
  as: PropTypes.string,
  className: PropTypes.string,
}

// HEADLINE 2 (GT America Standard Medium)
export const Headline2 = ({ className, as = 'h2', style, ...props }) => {
  const Element = as
  return <Element className={cn('headline2', className)} style={style} {...props} />
}

Headline2.propTypes = {
  as: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
}

// HEADLINE 3 (GT America Standard Medium)
export const Headline3 = ({ className, as = 'h3', ...props }) => {
  const Element = as
  return <Element className={cn('headline3', className)} {...props} />
}

Headline3.propTypes = {
  as: PropTypes.string,
  className: PropTypes.string,
}

// HEADLINE 4 (GT America Standard Medium)
export const Headline4 = ({ className, as = 'h4', ...props }) => {
  const Element = as
  return <Element className={cn('headline4', className)} {...props} />
}

Headline4.propTypes = {
  as: PropTypes.string,
  className: PropTypes.string,
}

// SUBTITLE (GT America Standard Medium)
export const Subtitle = ({ className, as = 'h3', vertical, children, ...props }) => {
  const Element = as
  return (
    <Element className={cn('subtitle', className, vertical && 'vertical')} {...props}>
      <span className={cn('inner')}>{children}</span>{' '}
    </Element>
  )
}

Subtitle.propTypes = {
  as: PropTypes.string,
  className: PropTypes.string,
  vertical: PropTypes.bool,
}

// BODY COPY (DM Sans Medium, GT America Standard Bold semiBold variant)
export const BodyCopy = ({ className, as = 'p', semiBold = false, ...props }) => {
  const Element = as
  return <Element className={cn('bodyCopy', className, semiBold && 'semiBold')} {...props} />
}

BodyCopy.propTypes = {
  as: PropTypes.string,
  className: PropTypes.string,
  semiBold: PropTypes.bool,
}
